<template>
  <div>
    <Form
      :model="searchItem"
      :label-width="85"
      label-position="left"
      :disabled="modal_loading"
      ref="formValidate"
      :show-message="false"
      style="margin-top:20px"
    >
      <Row style="margin-bottom: 0">
        <Col span="5">
          <FormItem label="标签名称">
            <Input v-model="searchItem.chName" />
          </FormItem>
        </Col>
        <Col span="1" offset="1">
          <Button type="primary" @click="getData()">{{ $t("Search") }}</Button>
        </Col>
      </Row>
    </Form>
    <Table
      stripe
      border
      :columns="columns1"
      :loading="modal_loading"
      :data="dataTable"
    >
      <template slot="slot" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(0, row)"
            type="md-eye"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
      <template slot="slot1" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(1, row)"
            type="ios-create"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
      <template slot="slot2" slot-scope="{ row }">
        <div>
          <Icon
            @click="openInternational(row)"
            type="md-globe"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
    </Table>
    <Page
      :total="this.totalNum"
      style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:-10px"
      @on-change="pageChange"
    />
    <Modal
      width="55%"
      v-model="visualPop"
      :title="columns1[transferType + 1].title"
    >
      <TabsTransferComponent
        v-if="visualPop"
        :transferData="transferData"
        :transferTitle="transferTitle"
        @transferChange="transferChange"
      ></TabsTransferComponent>

      <div class="bottomBtn" slot="footer">
        <Button @click="cancel()">取消</Button>
        <Button type="primary" @click="saveData()" style="margin-left:15px"
          >保存</Button
        >
      </div>
    </Modal>
    <Modal v-model="showInternational" :title="showTitle" width="800px">
      <Table border :columns="columns2" :data="data2" :loading="loading">
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total2"
            :page-size="pageInfo2.pageSize"
            @on-change="pageChange2"
          />
        </Col>
        <Col span="5" style="text-align:right;">
          <Button type="primary" @click="handleSaveAll">保存</Button>
        </Col>
      </Row>
      <div slot="footer" style="text-align:center">
        <!-- <Button type="text" @click="cancelClose()">取消</Button>
            <Button type="primary" @click="confirmSave()">保存</Button>-->
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import TabsTransferComponent from "./components/TabsTransferComponent";
export default {
  components: {
    TabsTransferComponent
  },
  data() {
    let t = this;
    return {
      searchItem: {},
      modal_loading: false,
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      columns1: [
        {
          title: "页签名称",
          key: "chName",
          align: "center"
        },
        {
          title: "可见内容",
          align: "center",
          slot: "slot"
        },
        {
          title: "可编辑内容",
          align: "center",
          slot: "slot1"
        },
        {
          title: "国际化设定",
          align: "center",
          slot: "slot2"
        }
      ],
      dataTable: [],
      visualPop: false,
      transferData: [],
      transferTitle: "",
      updatedData: [],
      transferType: "",
      showInternational: false,
      showTitle: "",
      columns2: [
        {
          title: "中文名称",
          key: "showChName",
          align: "center"
        },
        {
          title: "中文描述",
          key: "chName",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Input", {
                props: {
                  type: "text",
                  // autofocus:true,
                  // disabled:(params.row.edit == true ? false : true),
                  value: params.row.chName
                },
                on: {
                  "on-blur"(value) {
                    t.data2[params.index].chName = value.target.value;
                  }
                }
              })
            ]);
          }
        },
        {
          title: "英文描述",
          key: "enName",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Input", {
                props: {
                  type: "text",
                  // autofocus:true,
                  // disabled:(params.row.edit == true ? false : true),
                  value: params.row.enName
                },
                on: {
                  "on-blur"(value) {
                    t.data2[params.index].enName = value.target.value;
                  }
                }
              })
            ]);
          }
        }
        // {
        //   title: "操作",
        //   slot: 'action',
        //   width: "160",
        //   align: 'center',
        // }
      ],
      data2: [],
      pageInfo2: {
        pageNo: 1,
        pageSize: 10
      },
      total2: 0,
      sheetId: "",
      loading: false
    };
  },
  created() {
    this.getData();
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    handleSave() {
      this.loading = true;
      axios
        .post(
          "/FileInternationalViewSetController/updateAllSheetData",
          this.data2
        )
        .then(res => {
          this.loading = false;
          if (res) {
            this.$Message.success(this.$t("Save_Successful"));
          }
        });
    },
    handleSaveAll() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        onOk: () => {
          this.loading = true;
          axios
            .post(
              "/FileInternationalViewSetController/updateAllSheetData",
              this.data2
            )
            .then(res => {
              this.loading = false;
              if (res) {
                this.$Message.success(this.$t("Save_Successful"));
              }
            });
        }
      });
    },
    handleEdit(row) {
      row.edit = !row.edit;
    },
    getIntennational() {
      let obj = {
        sheetId: this.sheetId,
        pageNo: this.pageInfo2.pageNo,
        pageSize: this.pageInfo2.pageSize
      };
      axios
        .post("/FileInternationalViewSetController/selectSpecialData", obj)
        .then(res => {
          if (res) {
            this.data2 = res.data;
            // this.data2.forEach(item=>{
            //   item.edit = false
            // })
            this.total2 = Number(res.pageInfo.total);
          }
        });
    },
    openInternational(row) {
      this.showInternational = true;
      this.showTitle = row.chName;
      this.sheetId = row.sheetId;
      this.getIntennational();
    },
    pageChange2(val) {
      this.pageInfo2.pageNo = val;
      this.handleSave();
      this.getIntennational();
    },
    getData() {
      this.modal_loading = true;
      let json = {
        chName: this.searchItem.chName,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      axios.post("/UserSheet/searchSheetSet", json).then(res => {
        this.modal_loading = false;
        if (res) {
          this.dataTable = res.data;
          this.totalNum = Number(res.pageInfo.total);
        }
      });
    },
    openPop(index, row) {
      this.visualPop = true;
      let json = {
        sheetId: row.sheetId,
        chName: ""
      };
      axios.post("/UserSheet/searchSheetSet", json).then(res => {
        if (res) {
          this.transferTitle = row.chName;
          this.transferType = index;
          if (index == 0) {
            this.transferData = res.map(el => {
              return {
                ...el,
                key: el.showKey,
                label: el.chName,
                type: el.beShowSelf
              };
            });
          } else {
            this.transferData = res.map(el => {
              return {
                ...el,
                key: el.showKey,
                label: el.chName,
                type: el.beDisableSelf
              };
            });
          }
        }
      });
    },
    transferChange(item) {
      this.transferData.forEach(res => {
        if (this.transferType == 0) {
          res.beShowSelf = "0";
          item.forEach(element => {
            if (res.showKey == element) {
              res.beShowSelf = "1";
            }
          });
        } else {
          res.beDisableSelf = "0";
          item.forEach(element => {
            if (res.showKey == element) {
              res.beDisableSelf = "1";
            }
          });
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "<p></p>",
        onOk: () => {
          axios
            .post("/UserSheet/updateSheetSet", this.transferData)
            .then(res => {
              if (res) {
                this.$Message.info(res);
                this.visualPop = false;
              }
            });
        },
        onCancel: () => {}
      });
    },
    cancel() {
      this.visualPop = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/SystemSettings/PersonalFilesSetting.vue